<div [style.margin-bottom]="'1.429rem'">

    <div *ngFor="let item of units; let first = first"
        class="flex justify-content-between align-items-center w-full py-4"
        [ngClass]="{ 'border-top-1 surface-border': !first }">
        <div class="flex align-items-center gap-4 ml-2">
            <div class="flex flex-column">
                <span class="text-sm text-500">Código</span>
                <span class="text-xl font-bold text-700">{{ item.id }}</span>
            </div>
            <div class="flex flex-column">
                <span class="text-sm text-500">Unidade</span>
                <span class="text-xl font-bold text-700">{{ item.unitName }}</span>
            </div>
        </div>
        <div class="flex align-items-center">
            <button (click)="selectUnit(item.id)" pButton icon="pi pi-arrow-right"
                class="md:align-self-end p-button-rounded"></button>
        </div>
    </div>

</div>